module.exports = __webpack_public_path__ + "img/hlutur_logo_liten.bf102599.jpg";